import React from 'react';
import {Link, withRouter} from 'react-router-dom';

import PageHeader from './boxes/PageHeader';
import MainContent from './boxes/MainContent';
import * as invoiceActions from '../actions/invoice';
import { withTranslation } from 'react-i18next';


class CongratulationsPage extends React.Component{
    componentWillMount(){
        const {dispatch, user} = this.props;
        dispatch(invoiceActions.getClientInvoices(user.credentials.accessToken, user.companyInfo.id));
    }

    render(){
        const { history, t } = this.props;

        return (
        <MainContent>
            <PageHeader title="Receipt" />
                <div className="congrats-body-wrapper">
                    <h1>{t("congratulations.planPurchaseSuccesfulMessage")}</h1>
                    <p>{t("congratulations.nextStep")}</p>
                    <div className="steps-card">
                    <div className="steps-card-text">
                        <div className='step-card-image-1'>
                        </div>
                        <div className="step-card-steps">
                            <h2>{t("congratulations.step1Title")}</h2>
                            <p>{t("congratulations.step1Message")}</p>
                        </div>
                    </div>
                    <button
                        className={`primary_button step-card-btn`}
                        onClick={() => this.props.history.push('/dashboard/staff')}
                        // disabled={employeeCount === 0}
                    >
                        {t("congratulations.step1ActionButtonText")}
                    </button>
                    </div>
                    <div className='image-div'></div>
                    <div className='dots'></div>
                    <div className="steps-card">
                    <div className="steps-card-text">
                        <div className='step-card-image-2'>
                        </div>
                        <div className='step-card-steps'>
                            <h2>{t("congratulations.step2Title")}</h2>
                            <p>{t("congratulations.step2Message")}</p>
                        </div>
                    </div>
                    </div>
                    <div className='image-div'></div>
                    <div className='dots'></div>
                    <div className="steps-card">
                    <div className="steps-card-text">
                        <div className='step-card-image-3'>
                        </div>
                        <div className='step-card-steps'>
                            <h2>{t("congratulations.step3Title")}</h2>
                            <p>{t("congratulations.step3Message")}</p>
                        </div>
                    </div>
                    </div>
                    <div className='image-div'></div>
                </div>
            </MainContent>
        )
    }
}

const CongratulationsPageWithTranslation = withTranslation()(CongratulationsPage);
export default withRouter(CongratulationsPageWithTranslation);